//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "chargeback-popup-view",
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        workOrderId: {
            type: Number,
            required: true,
        },
        currentUserId: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            chargebackInputDto: {
                id: 0
            },
            saving: false
        }
    },
    methods: {
        onCancel() {
            this.shangMenInputDto = {
                id: 0,
                image: {
                    addAttrIds: [],
                    delAttrIds: []
                },
            };
            this.$emit('cancel', false)
        },
        onSave() {
            const vm = this;
            this.chargebackInputDto.workOrderId = this.workOrderId;
            this.chargebackInputDto.operateId = this.currentUserId;
            // console.log(this.chargebackInputDto)
            // return
            vm.saving = true;
            abp.ajax.post('/api/services/app/WorkOrder/WorkOrderChargeback', this.chargebackInputDto).then(res => {
                this.onCancel();
                this.$emit('save')
            }).finally(() => {
                vm.saving = false;
            })
        }
    },
    created() {
        console.log(this.currentUserId)
    }
}
